import RosterDrawer from '../Drawer/RosterDrawer';
import CarouselHighlighted from '../Section/CarouselHighlighted';
import FeedAward from '../Section/FeedAward';
import { Stack } from '@mui/material';
import LoadingModal from 'components/LoadingModal';
import { LayoutContext } from 'context/LayoutContext';
import navigationMenu from 'data/navigationMenu.json';
import { Text } from 'design/Text';
import _ from 'lodash';
import { onClickShare } from 'modules/helpers';
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { AwardsType } from 'redux/award/AwardProps';
import {
  fetchTournamentParticipantAwardsPlayerHighlighted,
  fetchTournamentParticipantAwardsPlayer,
} from 'redux/award/AwardService';
import { useAppSelector } from 'redux/hooks';
import { fetchPublicProfile, resetPublicProfile } from 'redux/publicProfile/slice';
import { useAppThunkDispatch } from 'redux/store';

const AwardList = () => {
  const { t } = useTranslation();
  const { setValue } = useContext(LayoutContext);
  const dispatch = useAppThunkDispatch();
  const { playerSlug } = useParams<{ playerSlug: string }>();
  const history = useHistory();

  const [error, setError] = useState<{ name: string; message: string; stack: string }>();
  const [openDrawerRoster, setIsOpenDrawerRoster] = useState(false);
  const [dataDrawerRoster, setDataDrawerRoster] = useState<any>([]);

  const {
    playerInfo,
    publicProfile,
    awardsHighlighted,
    awardList,
    publicProfileStatus,
    awardListStatus,
    awardsHighlightedStatus,
  } = useAppSelector(({ account, publicProfile, award }) => ({
    playerInfo: account?.data,
    publicProfile: publicProfile?.publicProfile,
    awardsHighlighted: award?.tournamentParticipantAwardsPlayerHighlighted?.awards,
    awardList: award?.tournamentParticipantAwardsPlayer?.awards,
    publicProfileStatus: publicProfile?.status?.publicProfile,
    awardListStatus: award?.status?.tournamentParticipantAwardsPlayer,
    awardsHighlightedStatus: award?.status?.tournamentParticipantAwardsPlayerHighlighted,
  }));

  const handleFetchPublicProfile = (playerSlug: string) => {
    dispatch(fetchPublicProfile({ playerSlug: playerSlug }))
      .unwrap()
      .then(res => {
        if (res) {
          handleFetchTournamentParticipantAwards(res.id);
          handleFetchTournamentParticipantAwardsPlayerHighlighted(res.id);
        }
      })
      .catch(error => setError(error));
  };

  const handleFetchTournamentParticipantAwardsPlayerHighlighted = (playerId: string) => {
    dispatch(fetchTournamentParticipantAwardsPlayerHighlighted({ playerId: playerId }))
      .unwrap()
      .catch(error => setError(error));
  };

  const handleFetchTournamentParticipantAwards = (playerId: string) => {
    dispatch(fetchTournamentParticipantAwardsPlayer({ playerId: playerId }))
      .unwrap()
      .catch(error => setError(error));
  };

  const handleOpenDrawerRoster = () => {
    setIsOpenDrawerRoster(!openDrawerRoster);
  };

  const handleBack = () => {
    if (history.action === 'POP') {
      return '/';
    }
    return 'goback';
  };

  const dataAwardFeed = _.chain(awardList)
    .orderBy(['split'], ['desc'])
    .groupBy('split')
    .map((value: any, key: any) => ({
      title: key,
      data: value,
      splitStart: value?.find((data: any) => data).splitStart,
      splitEnd: value?.find((data: any) => data).splitEnd,
    }))
    .value();

  const restructureData = (data: AwardsType) => {
    let returnData = {
      title: data.title,
      eventName: data.eventName,
      teamName: data.teamName,
      schoolName: data.schoolName,
      teamAvatarUrl: data.teamAvatarUrl,
      teamProvinceName: data.teamProvinceName,
      rosters: data.teamRoster,
    };
    return returnData;
  };

  const handleButtonRoster = (award: any) => {
    setDataDrawerRoster(restructureData(award));
    setIsOpenDrawerRoster(true);
  };

  const handleResetPublicProfile = () => {
    if (playerSlug !== playerInfo?.userName) {
      dispatch(resetPublicProfile());
    }
  };

  const handleLoading = (status: boolean) => {
    if (status) return !Boolean(publicProfile && awardsHighlighted && awardList);
    return false;
  };

  useEffect(() => {
    Promise.all([handleResetPublicProfile(), handleFetchPublicProfile(playerSlug)]);
  }, []);

  useEffect(() => {
    setValue({
      pageTitle: t('mabar_page_title', { title: 'Profile Player Statistic Awards' }),
      background: {
        color: 'neutral800',
      },
      appBar: {
        logo: false,
        back: {
          to: handleBack(),
        },
        menu: navigationMenu,
        title: (
          <Stack direction="column" sx={{ textAlign: 'center' }}>
            <Text variant="h3" sx={{ fontWeight: 700, letterSpacing: '0.12px' }}>
              Awards
            </Text>
            <Text variant="subtitle" sx={{ color: 'neutral400', mt: '2px' }}>
              {[publicProfile?.firstName ?? '', publicProfile?.lastName ?? ''].join(' ')}
            </Text>
          </Stack>
        ),
        share: (shareOpen: boolean, handleShare: () => void) => {
          if (shareOpen == true) {
            onClickShare({
              title: t('mabar_page_title', { title: 'Profile Player Statistic Awards' }),
              url: `${window.location.origin}/player/${playerSlug}/awards`,
              handleIconShare: () => handleShare(),
            });
          }
        },
      },
      padding: '0',
      bottomBar: {
        show: false,
      },
    });
  }, [playerInfo, publicProfile]);

  return (
    <>
      {awardsHighlighted && <CarouselHighlighted dataCarousel={awardsHighlighted} />}
      {dataAwardFeed && (
        <FeedAward dataFeed={dataAwardFeed} handleButtonRoster={handleButtonRoster} />
      )}

      <RosterDrawer
        open={openDrawerRoster}
        onClose={handleOpenDrawerRoster}
        onOpen={handleOpenDrawerRoster}
        dataEvent={dataDrawerRoster}
        playerId={playerInfo?.id ?? ''}
        title="AWARD"
        eventStatus={dataDrawerRoster?.title}
      />

      <LoadingModal
        show={
          error
            ? true
            : handleLoading(
                publicProfileStatus === 'loading' ||
                  awardListStatus === 'loading' ||
                  awardsHighlightedStatus === 'loading',
              )
        }
        isError={Boolean(error?.message)}
        errorMessage={error?.message}
      />
    </>
  );
};

export default AwardList;
